import { global_video_full_bleed_hero } from '../../../utils/requests/contentstack/contentStackZodSchema';
import type { VideoFullBleedHeroProps } from './VideoFullBleedHero';
import { getCloudinarySourceUrl } from '../../../utils/getCloudinaryItem/getCloudinaryItem';

export const videoFullBleedHeroSchema =
  global_video_full_bleed_hero.transform<VideoFullBleedHeroProps>(data => ({
    desktopVideo: getCloudinarySourceUrl(data.desktop_video),
    tabletVideo: getCloudinarySourceUrl(data.tablet_video),
    mobileVideo: getCloudinarySourceUrl(data.mobile_video),
    titleText: data.title.title_text,
    titleShadow: data.title.title_shadow,
    titleHiddenFromView: data.title.hide_title_from_view,
    ctaText: data.cta_text,
    ctaHref: data.cta_href,
    videoDescription: data.video_description,
    soundControls: data.sound_controls,
    captions: {
      url: getCloudinarySourceUrl(data.captions.file),
      default: data.captions.default,
      label: data.captions.label,
    },
    contentOrder: data.content_order,
    playPauseButtonSize: data.play_pause_button_size ?? 'large',
  }));
